import React, { PropsWithChildren } from "react";
import { Popover } from "antd";
import { AlertMessage } from "./alert-message";
import { AlertMessageBanner } from "./alert-message-banner";

export type AlertMessagePopoverProps = AlertMessage;

export const AlertMessagePopover = ({
  children,
  onClose,
  ...alertMessage
}: PropsWithChildren<AlertMessagePopoverProps>) => {
  return (
    <Popover
      content={<AlertMessageBanner {...alertMessage} />}
      onOpenChange={(visible) => onClose && !visible && onClose()}
    >
      {children}
    </Popover>
  );
};
